import { useCallback, useState } from 'react';

import type { ConfirmDialogProps } from '@lumapps/lumx-dialogs/components/ConfirmDialog';

export const usePublicationConfirmDialog = () => {
    const [state, setState] = useState<
        Pick<
            ConfirmDialogProps,
            'isOpen' | 'size' | 'title' | 'confirmMessage' | 'confirmProps' | 'parentElement' | 'onConfirm' | 'id'
        >
    >({
        isOpen: false,
        title: '',
        size: 'tiny',
        confirmMessage: '',
        onConfirm: () => {},
        confirmProps: {},
        id: '',
    });

    const closeConfirmDialog = useCallback(() => {
        setState((prevState) => ({ ...prevState, isOpen: false }));
    }, []);

    const openConfirmDialog = useCallback(
        ({ title, confirmMessage, onConfirm, confirmProps, size, id }: typeof state) => {
            const handleConfirm = () => {
                onConfirm();
                closeConfirmDialog();
            };
            setState({
                isOpen: true,
                size,
                title,
                confirmMessage,
                onConfirm: handleConfirm,
                confirmProps,
                id,
            });
        },
        [closeConfirmDialog],
    );

    return {
        dialogProps: state,
        openConfirmDialog,
        closeConfirmDialog,
    };
};
